<div mat-dialog-title>
</div>
<div mat-dialog-content>
    {{'generic.warning_before_leave' | translate}}
</div>
<div mat-dialog-actions>
    <button data-e2e="warning-confirm" (click)="close(true)" mat-raised-button>{{'generic.ok' | translate}}</button>
    <button data-e2e="warning-cancel" (click)="close(false)" mat-raised-button>{{'generic.cancel' | translate}}</button>
</div>
